import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useSelector} from 'react-redux';
import {selectBrand} from 'src/selectors/referral-external';
import {selectUserAgent} from 'src/selectors/accounts';
import {DEFAULT_TEXT_COLOR} from 'src/utils/referral-external';
import {isMobile} from 'src/utils/responsive';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  SubTitleLarge,
} from '@spaced-out/ui-design-system/lib/components/index';


type FormModalProp = {
  header: React.ReactNode | string;
  size?: 'small' | 'medium' | 'large';
  children: React.ReactNode;
  onClose: () => unknown;
  onSubmit?: () => unknown;
  showFooter?: boolean;
  isOpen: boolean;
};

const FormModal = ({
  header,
  size = 'medium',
  children,
  onClose,
  onSubmit,
  showFooter = false,
  isOpen,
}: FormModalProp) => {
  const {t} = useLabelTranslation();
  const brand = useSelector(selectBrand);
  const userAgent = useSelector(selectUserAgent);
  return (
    <Modal
      onClose={onClose}
      size={isMobile(userAgent) ? 'small' : size}
      isOpen={isOpen}
    >
      <ModalHeader onCloseButtonClick={onClose}>
        <SubTitleLarge>{header}</SubTitleLarge>
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      {showFooter && (
        <ModalFooter>
          <Button
            type="tertiary"
            onClick={onClose}
            style={{
              borderColor: brand.button_color,
              boxShadow: `0 0 0 2px ${brand.button_color}`,
              opacity: '0.7',
              color: DEFAULT_TEXT_COLOR,
              backgroundColor: brand.button_color,
            }}
          >
            {t('No', 'No')}
          </Button>
          <Button
            style={{
              backgroundColor: brand.button_color,
              boxShadow: `0 0 0 2px ${brand.button_color}`,
              color: DEFAULT_TEXT_COLOR,
            }}
            onClick={onSubmit}
          >
            {t('Yes', 'Yes')}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default FormModal;
